//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

export const INJECTOR_ROOT_ELEMENT_SELECTOR = '[ng-app],[async-session-app]';

export default function getAngularInjector() {
  return angular.element(INJECTOR_ROOT_ELEMENT_SELECTOR).injector();
}
